import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight, Home } from 'lucide-react';

/**
 * Visual breadcrumb trail. Used in tandem with BreadcrumbList JSON-LD that is
 * emitted by the page-level Seo component.
 *
 * Props:
 *   items: [{ label, url }]  — last item is treated as current page
 */
const Breadcrumbs = ({ items }) => {
  return (
    <nav aria-label="Breadcrumb" className="text-sm text-gray-400" data-testid="breadcrumbs">
      <ol className="flex flex-wrap items-center gap-1.5">
        {items.map((it, i) => {
          const isLast = i === items.length - 1;
          return (
            <li key={i} className="flex items-center gap-1.5">
              {i === 0 ? <Home className="w-3.5 h-3.5" /> : <ChevronRight className="w-3.5 h-3.5 text-gray-600" />}
              {isLast ? (
                <span className="text-gray-200" aria-current="page">{it.label}</span>
              ) : (
                <Link to={it.url} className="hover:text-amber-500 transition-colors">{it.label}</Link>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
};

export default Breadcrumbs;
